/**
 * Shared mutable store for OTel user attributes.
 *
 * OpenTelemetry is initialized in index.tsx before React renders,
 * but the authenticated user's lanId isn't available until after
 * the auth flow completes inside the React tree. This module bridges
 * that gap: index.tsx passes `getOtelUserAttributes` as the
 * `attributesFn` callback, and App.tsx calls `setOtelUserId` once
 * the session is available. The callback is invoked lazily on every
 * span, log, and metric emission, so it always returns the latest value.
 */

let userId = ''

export function setOtelUserId(lanId: string) {
    userId = lanId
}

export function getOtelUserAttributes(): Record<string, string> {
    if (!userId) return {}
    return { 'user.id': userId }
}
